import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from "react-datepicker";

const DatePickerComponent = (props) => {
    const { dateField, handleDateChange, fieldName, dateFormat, timeSelect = false, isRange = false, showFutureDate = true } = props;
    return (
        <DatePicker
            className="date-picker form-control"
            showIcon
            autoComplete='one-time-code'
            dateFormat={dateFormat || "MM-dd-yyyy"}
            showTimeSelect={timeSelect}
            selected={dateField ? new Date(dateField) : null}
            onChange={(date) => handleDateChange(date, fieldName)}
            name={'dateField'}
            adjustDateOnChange
            selectsRange={isRange}
            maxDate={!showFutureDate ? new Date() : null}
            {...props}
        />
    );
};

DatePickerComponent.propTypes = {
    dateField: PropTypes.string,
    handleDateChange: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
    dateFormat: PropTypes.string,
    timeSelect: PropTypes.bool,
    isRange: PropTypes.bool,
    showFutureDate: PropTypes.bool
};

export default DatePickerComponent;